import { useCallback, useEffect, useRef, useState } from 'react'

export function useDeferredInput(externalValue: string, onCommit: (value: string) => void) {
	const [localValue, setLocalValue] = useState(externalValue)
	const isFocusedRef = useRef(false)
	const localValueRef = useRef(localValue)
	localValueRef.current = localValue
	const externalValueRef = useRef(externalValue)
	externalValueRef.current = externalValue
	const onCommitRef = useRef(onCommit)
	onCommitRef.current = onCommit

	useEffect(() => {
		if (!isFocusedRef.current) {
			setLocalValue(externalValue)
		}
	}, [externalValue])

	useEffect(() => {
		return () => {
			if (isFocusedRef.current && localValueRef.current !== externalValueRef.current) {
				onCommitRef.current(localValueRef.current)
			}
		}
	}, [])

	const handleChange = useCallback((value: string) => {
		setLocalValue(value)
	}, [])

	const handleFocus = useCallback(() => {
		isFocusedRef.current = true
	}, [])

	const handleBlur = useCallback(() => {
		isFocusedRef.current = false
		if (localValueRef.current !== externalValueRef.current) {
			onCommitRef.current(localValueRef.current)
		}
	}, [])

	return { localValue, handleChange, handleFocus, handleBlur }
}
